import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';

const store = {
  namespaced: true,
  state: {
    records: [],
    historyList: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setpage(state, page) {
      state.pagination = page;
    },
    setRecords(state, payload) {
      state.records = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    sethistory(state, payload) {
      state.historyList = payload;
    }
  },
  actions: {
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    add(context, data) {
      return api.add(data);
    },
    seachHis({ commit }, query) {
      api.seachHis(query).then(({ data }) => {
        commit('sethistory', data);
      });
    }
  }
};

appStore.registerModule('kpi', store);
